export class Sale {

    id: any;
    amount: any;
    amountPaid: any;
    difference: any;
    payment: any;
    productSolds: any;
    typeSale: string;
    clientSolds: any;
    observation: string;
    formPayment: string;
    createdAt: string;
    clientName: string;
    status: any;
    amountPaidTwo: any;
    paymentTwo: any;

    constructor(id: any, amount: any, amountPaid: any, difference: any,
        payment: any, productSolds: any , typeSale: string,clientSolds: any,observation: string,
        formPayment: string,createdAt: string,clientName: string,status: any,amountPaidTwo: any,
        paymentTwo: any) {
        this.id = id;
        this.amount = amount;
        this.amountPaid = amountPaid;
        this.difference = difference;
        this.payment = payment;
        this.productSolds = productSolds;
        this.typeSale = typeSale;
        this.clientSolds = clientSolds;
        this.observation = observation;
        this.formPayment = formPayment;
        this.createdAt = createdAt;
        this.clientName = clientName;
        this.status = status;
        this.amountPaidTwo = amountPaidTwo;
        this.paymentTwo = paymentTwo;
    }   
}